import ReportsAdapter from './base';

export default class StudentReport extends ReportsAdapter {
  modelNamePlural = 'student-reports';

  urlForCreateRecord(modelName, snapshot) {
    let url = super.urlForCreateRecord(...arguments);
    if (snapshot.adapterOptions && snapshot.adapterOptions.createSections) {
      url += (url.includes('?') ? '&' : '?') + 'createSections=true';
    }
    return url;
  }
}
